import type { PlatformStatusData } from '@/api-types';

const defaultStatus: PlatformStatusData = {
    globalUserMessage: '',
    changeLogs: '',
    hasActiveMessage: false,
};

export function usePlatformStatus() {
    // For CSR architecture, we don't have a backend to fetch platform status from
    // Return the default status (no messages)
    return {
        status: defaultStatus,
    };
}
